export default [
  {
    id: "pusterla-pollards-induction-2022.pdf",
    title: "Company Induction"
  },
  {
    id: "pusterla-pollards-support-staff-ethics-2022.pdf",
    title: "Ethics Overview"
  },
  {
    id: "pusterla-pollards-support-staff-anti-bribery-corruption-2022.pdf",
    title: "Anti Bribery and Corruption Overview"
  },
  {
    id: "pusterla-pollards-support-staff-human-rights-2022.pdf",
    title: "Human Rights Overview"
  },
  {
    id: "modern-slavery-statement.pdf",
    title: "Modern Slavery"
  },
  {
    id: "pusterla-pollards-manual-handling-2022.pdf",
    title: "Manual Handling"
  },
  {
    id: "pusterla-pollards-safety-knives.pdf",
    title: "Safety Knives"
  },
  {
    id: "sow-no-29-glue-lines-march-22.pdf",
    title: "Glue Lines SOW"
  }
];
